import { CustomCheckoutShippingStateType } from "@iewc/Store/State/CheckoutShipping/CheckoutShippingState";
import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: CustomCheckoutShippingStateType = {
    cartLines: [],
    redirectToCartPage: false,
};

export const customCheckoutShippingReducer = createTypedReducer(initialState, {
    "Custom/CheckoutShipping/CartLines": (
        draft: Draft<CustomCheckoutShippingStateType>,
        cartLines: { cartLines: [] },
    ) => {
        return {
            ...draft,
            ...cartLines,
        };
    },
    "Custom/CheckoutShipping/RedirectToCartPage": (
        draft: Draft<CustomCheckoutShippingStateType>,
        redirectToCartPage: { redirectToCartPage: boolean },
    ) => {
        return {
            ...draft,
            ...redirectToCartPage,
        };
    },
});
